import { render } from "./ListAll.vue?vue&type=template&id=0c636512"
import script from "./ListAll.vue?vue&type=script&lang=js"
export * from "./ListAll.vue?vue&type=script&lang=js"

import "./ListAll.vue?vue&type=style&index=0&id=0c636512&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__